/**
 * Top Header Carousel for Mobile
 * Simple cross-fade carousel with no glitches
 */

(function() {
  'use strict';
  
  const MOBILE_BREAKPOINT = 768;
  const DISPLAY_TIME = 8000; // How long each item is shown
  const FADE_TIME = 500; // Fade transition time
  
  class TopHeaderCarousel {
    constructor(element) {
      this.topHeader = element;
      this.items = Array.from(element.querySelectorAll('.top-header__item'));
      this.currentIndex = 0;
      this.intervalId = null;
      
      console.log('Carousel initialized with', this.items.length, 'items');
      
      if (this.items.length > 1) {
        this.init();
      }
    }
    
    init() {
      // Set initial state - first item visible, others hidden
      this.items.forEach((item, i) => {
        item.classList.remove('top-header__item--visible', 'top-header__item--hidden');
        if (i === 0) {
          item.classList.add('top-header__item--visible');
        } else {
          item.classList.add('top-header__item--hidden');
        }
      });
      
      // Start the rotation
      this.start();
      console.log('Carousel started');
    }
    
    start() {
      this.intervalId = setInterval(() => {
        this.showNext();
      }, DISPLAY_TIME);
    }
    
    stop() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
    
    showNext() {
      const currentItem = this.items[this.currentIndex];
      const nextIndex = (this.currentIndex + 1) % this.items.length;
      const nextItem = this.items[nextIndex];
      
      // Hide current item
      currentItem.classList.remove('top-header__item--visible');
      currentItem.classList.add('top-header__item--hidden');
      
      // Show next item
      nextItem.classList.remove('top-header__item--hidden');
      nextItem.classList.add('top-header__item--visible');
      
      // Update index
      this.currentIndex = nextIndex;
      
      console.log('Showing item', this.currentIndex);
    }
    
    destroy() {
      this.stop();
      this.items.forEach(item => {
        item.classList.remove('top-header__item--visible', 'top-header__item--hidden');
      });
    }
  }
  
  // Global instance
  let instance = null;
  
  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }
  
  function init() {
    console.log('Init - isMobile:', isMobile());
    
    // Cleanup existing
    if (instance) {
      instance.destroy();
      instance = null;
    }
    
    // Only on mobile
    if (!isMobile()) {
      return;
    }
    
    // Find carousel
    const carousel = document.querySelector('.top-header[data-mobile-layout="carousel"]');
    
    if (carousel) {
      console.log('Creating carousel instance');
      instance = new TopHeaderCarousel(carousel);
    }
  }
  
  // Init when ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Handle resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 300);
  });
  
  // Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:reorder', init);
  }
  
})();
